import { useContext, useEffect } from 'react'
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext'
import { Flex, Text, Box } from '@mantine/core'
import { MAIN_DARK_PRIMARY } from '../../../../constants/colors'
import CustomersNamesBars from './CustomersNamesBars'
import SegmentAttributes from './SegmentAttributes'

const CustomersBars = () => {

  const { customers, viewType } = useContext(SingleCustomerContext)

  useEffect(() => {
    // This will run whenever isSegmentSelection changes
    console.log('Segment selection state changedssssssssss:', viewType);
  }, [viewType]);

  return (
    <Box>
      <Flex py={6} mb={12}>
        <Text fz={18} fw={600} color={MAIN_DARK_PRIMARY} mr={4}>{customers?.length}</Text>
        <Text fz={18} fw={600} color={MAIN_DARK_PRIMARY}>Customers</Text>
      </Flex>
      {viewType === 'segment'
        ?
        <SegmentAttributes />
        :
        <CustomersNamesBars customers={customers} />
      }
    </Box>
  )
}

export default CustomersBars